<template>
    <!-- <div class="modal" id="modalConfirmation" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ title }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p v-html="text"></p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary btn-sm" @click="confirm">SIM</button>
                    <button type="button" class="btn btn-secondary btn-sm" @click="hideModel">NÃO</button>
                </div>
            </div>
        </div>
    </div> -->
    <modal
        :show="show"
        :title="translatedModalTitle"
        :saveButton="{title:'Sim', btnClass: {'btn btn-main btn-rounded btn-sm z-depth-0': true}}"
        :cancelButton="{title:'Não', btnClass: {'btn btn-outline-main btn-rounded btn-outline btn-sm z-depth-0': true}}"
        size="small"
        :needHeader="false"
        :relativeBackdrop="true"
        :contentCentered="true"
        class="modal-confirmation"
        @close="onClose"
        @save="onConfirm">
        <p v-html="translatedText"></p>
    </modal>
</template>

<script>
import Modal from './Modal';
export default {
    name: 'modal-confirmation',
    components: { Modal },
    props: ['title'],
    data() {
        return {
            show: false,
            fn_callback: null,
            fn_cancel: null,
            itemId: null,
            modalTitle: null,
            text: null,
            index: null,
            itemData: null,
        }
    },
    mounted() {
        this.modalTitle = this.title;
    },
    computed: {
        translatedModalTitle() {
            return this.$t(this.modalTitle);
        },
        translatedText() {
            return this.$t(this.text);
        }
    },
    methods: {
        open: function(callback, itemId, index, text, itemData, title=null, cancel=null) {
            this.show=true;
            this.fn_callback = callback;
            this.fn_cancel = cancel;
            this.itemId = itemId;
            this.index = index;
            this.text = text;
            this.itemData = itemData || null;
            if(title){
                this.modalTitle = title;
            }
        },
        closeModal: function() {
            this.show=false;
        },
        onClose: function() {
            this.callCancel();
        },
        onConfirm: function() {
            this.callCallback();
        },
        callCallback: function() {
            this.closeModal();
            if(this.fn_callback){
                this.fn_callback(this.itemId, this.itemData);
            }
        },
        callCancel: function() {
            this.closeModal();
            if(this.fn_cancel){
                this.fn_cancel(this.itemId, this.itemData);
            }
        }
    }
}
</script>